import { black3, evisortBlue } from '../../../assets/shared-styles/general';

const styles = {
  selectedOption: {
    position: 'relative',
    alignItems: 'center',
    display: 'flex',
    padding: '3px 5px',
    borderBottom: '1px solid #ccc',
    backgroundColor: '#fff',
    color: evisortBlue,
    fontSize: '14px',
    justifyContent: 'space-between',
  },
  accountDepartmentItem: {
    display: 'flex',
    alignItems: 'center',
  },
  accountDepartmentSelected: {
    width: '120px',
    color: black3,
  },
  allowDownloadWrapper: {
    marginRight: '10px',
  },
  allowDownloadContainer: {
    display: 'flex',
    alignItems: 'center',
    '& label': {
      color: black3,
    },
  },
  removeDepartmentIconWrapper: {
    padding: 0,
    cursor: 'pointer',
    '& svg': {
      flexShrink: 0,
      marginLeft: '8px',
    },
  },
};

export default styles;
